import React, { useCallback, useState } from "react"
import { Alert, Box, Button, Checkbox, CircularProgress, Dialog, DialogTitle, FormControl, Grid, IconButton, Link, Paper, Snackbar, TextField, Typography } from "@mui/material"
import { submitCaseFiles } from "../data/ingester"
import debounce from "debounce"
import { CheckCircle } from "@mui/icons-material"
import { disclaimer } from "../utils/constants"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { PdfViewer } from "../components"
// import { useNavigate } from "react-router-dom"

// const SubmitFiles = ({doctorId, link}) => {
const SubmitFiles = ({ listaDeDados }) => {
    console.log("listaDeDados", listaDeDados)
    const [snackStatus, setSnackStatus] = useState({open:false, severity:"", msg: "" })
    const [disableButton, setDisableButton] = useState(false)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [isChecked, setIsChecked] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState({})
    const [errorMessage, setErrorMessage] = useState("")
    const [openFile, setOpenFile] = useState(false)
    const [title, setTitle] = useState()
    // const navigate =  useNavigate()

    const categoriasDesabilitadas = listaDeDados.map(item => item.categoria);
    // console.log("categoriasDesabilitadas", categoriasDesabilitadas)
    const doctorId = listaDeDados[0]?.idMedico || 0;
    const link = listaDeDados[0]?.link || "";

    const handleSnackClose = () => {
        setSnackStatus({open:false})
    }

    const sendFiles = async (filesWithIds) => {
        setLoading(true)
        const formData = new FormData()
        formData.append('idmedico', doctorId.toString())
        formData.append('link', link)
        // formData.append('ativo', 'false')
        formData.append('ativo', 'true')

        filesWithIds.forEach(({ file, id }) => {
            formData.append('file', file)
            const incrementedId = (parseInt(id, 10) + 1).toString()  // Adiciona o ID do arquivo, incrementando o valor numérico em 1
            formData.append('file_id', incrementedId)
        })
        const resp = await submitCaseFiles({...{formData}})
        if(!resp) {
            setSnackStatus({open:true, severity:"error", msg: "Erro: Operação não realizada." })
            setDisableButton(false)
        } else {
            setSuccess(true)
        }
        setLoading(false)
    }

    const handleSubmit = () => {
        const filesWithIds = Object.values(selectedFiles).filter(fileObj => fileObj.file != null)
        const fileCount = filesWithIds.length

        if (fileCount === 0) {
            setErrorMessage('Selecione ao menos 1 arquivo.')
            setDisableButton(false)
        } else if (filesWithIds.findIndex((item) => item.file?.type != "application/pdf") >= 0) { 
            setErrorMessage('Apenas arquivos PDF são aceitos.')
            setDisableButton(false)
        } else {
            setErrorMessage('')
            sendFiles(filesWithIds)
        }
    }

    const handleDebounceLink = debounce(handleSubmit, 300)
    const handleCallBackSubmission = useCallback(()=>{
        setDisableButton(true)
        handleDebounceLink()
    }, [selectedFiles, doctorId, link])

    const handleFileChange = (key, event) => {
        setErrorMessage('')
        const file = event.target.files ? event.target.files[0] : null
        setSelectedFiles(prevState => ({
            ...prevState,
            [key]: { file, id: key }
        }))
    }

    const handleCheck = (event) => {
        setIsChecked( event.target.checked)
    }

    const handleOpenCloseFileDialog = () => {
        setOpenFile(!openFile)
    }

    // const onClose = ()=> {
    //     navigate('/')
    // }

    const categories = [
        {
            title: "Categoria 1- IMPACTO NA FUNÇÃO PULMONAR",
            description: "Casos clínicos de pacientes em uso de Trikafta mostrando melhora significativa nas métricas de função pulmonar (ex.: VEF1)."
        },
        {
            title: "Categoria 2- RESULTADOS NA ENDOCRINOLOGIA/ NUTRIÇÃO/GI",
            description: "Casos clínicos de pacientes em uso de Trikafta mostrando melhora no status nutricional, sintomas gastrointestinais e/ou hormonais."
        },
        {
            title: "Categoria 3- MANEJO DOS EVENTOS ADVERSOS E COMORBIDADES",
            description: "Casos clínicos de pacientes em uso de Trikafta que demonstrem o manejo de condições pré-existentes e concomitantes ao tratamento como por exemplo, e não se limitando a: diabetes, doença hepática ou osteoporose."
        },
        {
            title: "Categoria 4- RESPOSTA TERAPÊUTICA NO TESTE DO SUOR E INTERVENÇÃO PRECOCE",
            description: "Casos clínicos de pacientes em uso de Trikafta com resposta sustentada ao longo do tempo correlacionado com o quadro clínico do paciente (ex.: teste do suor) E/OU pacientes com resposta rápida ao teste do suor em pacientes com 6 anos."
        },
        {
            title: "Categoria 5- ADESÃO E QUALIDADE DE VIDA",
            description: "Casos clínicos que demonstrem estratégias para a melhora da adesão ao tratamento e a qualidade de vida com o uso de Trikafta."
        },
        {
            title: "Categoria 6- DIAGNÓSTICO DIFERENCIAL PARA FC",
            description: "Casos clínicos que demonstrem a jornada do diagnóstico diferencial da FC em pacientes que tinham sinais prévios como infecções pulmonares de repetição, infertilidade masculina, rinusinusite crônica com pólipos nasais, pancreatite de repetição, ou outros diagnósticos como bronquiectasia, asma ou DPOC, entre outros."
        }
        
    ]
    const DescComp = ({title, description}) => {
        return (
            <Box sx={{ml:"32px"}}>
                <Typography className="titleAMT" textTransform="uppercase">
                    {title}
                </Typography>
                <Typography  variant="body1" textAlign="justify">
                    {description}
                </Typography>
            </Box>
        )
    }
    return (    
        <Box className="mainBox">
            <Dialog fullWidth maxWidth="md" onClose={handleOpenCloseFileDialog} open={openFile}>
                <DialogTitle sx={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <>
                    {title}
                    <IconButton onClick={handleOpenCloseFileDialog}>
                        <CloseRoundedIcon fontSize="medium" />
                    </IconButton>
                    </>
                </DialogTitle>
                <PdfViewer url={`https://fc30.com.br/pdfs/${encodeURIComponent(title)}`} />
            </Dialog>

            <Snackbar
                anchorOrigin={{ vertical:"top", horizontal:"right" }}
                autoHideDuration={6000}
                open={snackStatus?.open}
                onClose={handleSnackClose}
            >
                <Alert
                    onClose={handleSnackClose}
                    severity={snackStatus?.severity}
                    variant="standard"
                    sx={{ width: '100%', p:2, textTransform:"uppercase"}}
                >
                    {snackStatus?.msg}
                </Alert>
            </Snackbar>
            <Box className="loginLogo"/>
            {!success &&
                <Grid container sx={{ width: "100%", justifyContent:"center" }} gap={4}>
                    {categories.map((category, index)=>{
                        return (
                        <Grid key={index} container item xs={12}>
                            <Grid item md={4}>
                                <FormControl sx={{width:"100%", height:"100%"}}>
                                    {/* <TextField 
                                        type="file" 
                                        name="pdf1" 
                                        accept=".pdf"
                                        disabled={categoriasDesabilitadas.includes(index)}
                                        // disabled={success} 
                                        onChange={event => handleFileChange( index, event)}
                                    /> */}
                                    {categoriasDesabilitadas.includes(index+1) ? (
                                        <TextField
                                            disabled
                                            value="Você já submeteu um caso clínico para essa categoria"
                                            InputProps={{ readOnly: true }}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "red !important", // borda vermelha fixa
                                                },
                                                },
                                            }}
                                        />
                                        ) : (
                                        <TextField
                                            type="file"
                                            name="pdf1"
                                            accept=".pdf"
                                            onChange={(event) => handleFileChange(index, event)}
                                        />
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item md={8} sx={categoriasDesabilitadas.includes(index+1) ? { opacity: 0.5, pointerEvents: 'none' } : {}}>
                                <DescComp {...{title: category.title, description: category.description}}/> 
                            </Grid>
                        </Grid>
                        )
                    })}
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                            <Checkbox checked={isChecked} onChange={(event)=>handleCheck(event)} />
                            <Typography className="privacylink" >
                                {"Ao clicar em enviar declaro que li e concordo com o "}
                            </Typography>
                            {/* <Link className="privacylink" href="/terms" target="_blank" rel="noopener" >
                                {" Aviso de Privacidade do Concurso de Casos Clínicos. "}
                            </Link> */}
                            <span
                                className="privacylink"
                                style={{ cursor: "pointer", textDecoration: "underline", color: "#1976d2" }}
                                onClick={() => {
                                    handleOpenCloseFileDialog();
                                    setTitle("Aviso_Privacidade.pdf");
                                }}
                                >
                                Aviso de Privacidade do Concurso de Casos Clínicos. 
                            </span>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                            {/* <Link className="privacylink" href="/docs/REGULAMENTO PROGRAMA Casos Clínicos_V3.pdf" target="_blank" rel="noopener noreferrer" >
                                {"Acesso ao regulamento"}
                            </Link> */}
                            <span
                                className="privacylink"
                                style={{ cursor: "pointer", textDecoration: "underline", color: "#1976d2" }}
                                onClick={() => {
                                    handleOpenCloseFileDialog();
                                    setTitle("REGULAMENTO PROGRAMA Casos Clínicos_V3.pdf");
                                }}
                                >
                                Acesso ao regulamento
                            </span>
                        </Box>
                    </Grid>
                    
                    <Box sx={{mb:"150px"}}>
                        {errorMessage.length > 0 &&
                            <Paper className="errorPaper" elevation={0}>{errorMessage}</Paper> 
                        }
                        {!loading && !success &&
                        <Button className="avaliateButtonAMT loginItem" disabled={!isChecked || disableButton} onClick={handleCallBackSubmission} >
                            <Typography variant="body2" >
                                {"Enviar"}
                            </Typography>
                        </Button>
                        }
                        {loading &&
                            <>
                            <Typography className="titleAMT">
                                {"Aguarde mais alguns instantes, seu(s) Caso(s) Clínicos estão sendo enviados ..."}
                            </Typography>
                            <Box sx={{width:"100%", textAlign:"center" }}>
                                <CircularProgress/>
                            </Box>
                            </>
                        }
                        {success &&
                        <Paper className="successPaper" elevation={0}>
                            <Typography variant="body2" >
                                {"ARQUIVOS ENVIADOS!"}
                            </Typography>
                            <CheckCircle fontSize="large"/>
                        </Paper> 
                        }  
                    </Box>
                    <Paper
                        className="disclaimer"
                        elevation={0}
                        dangerouslySetInnerHTML={{ __html: disclaimer }}
                    />
                </Grid>
            }
            {success &&
            <Grid container sx={{justifyContent:"center" }}>
                <Paper className="successSinglePaper" elevation={0}>
                    <Typography className="titleAMT" variant="h5">
                        {"Os casos clínicos foram enviados com sucesso!"}
                    </Typography>
                    {/* <Button className="avaliateButtonAMT loginItem" onClick={()=>onClose()} >
                    <Typography variant="body2" textTransform="uppercase" >
                        {"Clique aqui para sair"}
                    </Typography>
                    </Button> */}
                </Paper> 
            </Grid>
            }
        </Box>
    )
}
export default SubmitFiles
